import React from "react";
import "./StepThree.style.scss";
import arrayImgs from "../../imgs/scammer";
import SliderScammerComponent from "../slider/Slider_scammer";

export default function StepThree() {
    const arrayText = [
        "Нікому та ніколи не називайте PIN-код до карти, пароль для входу в інтернет-банкінг, коди з смс/повідомлень у месенджерах тощо. Представники Justin, вашого банку, комунальних служб та інші ніколи не запитують ці дані. Якщо хтось про це запитує – це 100% шахрайство.",
        "Регулярно перевіряйте список довірених пристроїв (мобільних телефонів, ПК), які мають доступ до ваших облікових записів. Видаляйте ті, якими ви не користуєтеся.",
        "Не передавайте стороннім особам скани ваших документів (паспорт, ІПН). Justin сканує документи лише у разі оплати готівкою на суму понад 5000 грн. Якщо сторонні особи просять вас для оформлення замовлення надати скани документів – це 100% шахрайство.",
        "Ніколи та нікому не передавайте CVV-код (3-значний номер на звороті банківської карти). Це ключ до вашого рахунку. Він необхідний виключно для введення вами при онлайн-оплаті. Якщо хтось просить вас назвати ці цифри – це 100% шахрайство.",
        "Телефонуйте до банку лише за номером, вказаним на звороті своєї картки. Якщо ви отримали повідомлення від банку про блокування картки, підтвердження списання коштів за купівлю, яку ви не робили – ні в якому разі не дзвоніть на цей номер.",
    ];
    return <div className="step_three_scammer">
        <div className="wrapper_text">
            <p>Що ще потрібно знати:</p>
            <SliderScammerComponent arrayText={arrayText}/>
        </div>
        <img id="female" src={arrayImgs.Female} alt="scammer"/>
    </div>
}